import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=3ee06da7&"
import script from "./SchoolCard.vue?vue&type=script&lang=js&"
export * from "./SchoolCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports